import { useState } from 'react';
import '../../Style/product/details-product-section.css';
import CardButtonProductWidget from '../../Widgets/card-button-product/CardButtonProductWidget';
import CardValueProductWidget from '../../Widgets/card-value-product/CardValueProductWidget';
import CardValueProductWidgetOld from '../../Widgets/card-value-product/CardValueProductWidgetOld';
import { openInNewTab, isNullOrEmpty } from '../../Services/service';
import { t } from 'i18next';
import CardValueDefaultProductWidget from '../../Widgets/card-value-product/CardValueDefaultProductWidget';

function DetailsProductSection ({objectDto, setObjectDto, setIsLoading, targetRef}) {
    const [listRule, setListRule] = useState([{"title": t("producttnc"), "onClick": ()=>{openInNewTab("/rule/Quy tắc và Điều khoản.pdf")}}, 
                                                {"title": t("referenceinfor"), "onClick": ()=>{openInNewTab("/rule/Tài liệu giới thiệu sản phẩm.pdf")}}, 
                                                {"title": t("referencebenefit"), "onClick": ()=>{openInNewTab("/rule/Tài liệu minh họa quyền lợi sản phẩm.pdf")}}, 
                                                {"title": t("referencefee"), "onClick": ()=>{openInNewTab("/rule/Biểu phí.pdf")}}, 
                                                
                                            ]);
    return(
        <section className="details">
            <div className='details-form-wrap'>
                <div className='details-form' ref={targetRef} tabIndex={-1}>
                    <label className="details-label-title-form product-title-label">{t("policybenefit")}</label>
                    <label className="details-label-desc-form product-desc-label">{t("productruledetails")}</label>
                    <div className='details-card-list-product'>
                        {
                            objectDto.productList !== undefined && objectDto.productList.length > 0
                            ? 
                            objectDto.productList.map((item, index) => {
                                return isNullOrEmpty(objectDto.discount) || objectDto.discount <=0
                                    ? (
                                        <CardValueProductWidgetOld
                                            key={index}
                                            id={index}
                                            setIsLoading={setIsLoading}
                                            selected={item}
                                            objectDto={objectDto}
                                            setObjectDto={setObjectDto}
                                        />
                                    )
                                    : (
                                        <CardValueProductWidget
                                            key={index}
                                            id={index}
                                            setIsLoading={setIsLoading}
                                            selected={item}
                                            objectDto={objectDto}
                                            setObjectDto={setObjectDto}
                                        />
                                    );
                            })
                            :
                                <>
                                    <CardValueDefaultProductWidget id={"0001"} title={"Cơ Bản"} value={"100.000.000"} total={"500.000"}/>
                                    <CardValueDefaultProductWidget id={"0002"} title={"Nâng Cao"} value={"200.000.000"} total={"1.500.000"}/>
                                    <CardValueDefaultProductWidget id={"0003"} title={"Ưu Việt"} value={"400.000.000"} total={"3.000.000"}/>
                                </>
                        }
                    </div>
                    <label className="details-label-title-form product-title-label">{t("productinformation")}</label>
                    <ul style={{marginBottom: "2%", paddingLeft: "2%"}}>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation1")}</li>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation2")}</li>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation3")}</li>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation4")}</li>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation5")}</li>
                        <li className="details-label-desc-form product-desc-label">{t("productinformation6")}</li>
                    </ul>
                    <label className="details-label-title-form product-title-label">{t("productreferences")}</label>
                    {
                        listRule.map((item, index)=> {
                            return <CardButtonProductWidget onClickNavigate={item.onClick} title={item.title} key={index}/>
                        })
                            
                    }
                    
                </div>
            </div>
        </section>
    );
}

export default DetailsProductSection;